<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#00173E">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M.784.089l.07.057L6 5.293 11.146.146c.196-.195.512-.195.708 0 .173.174.192.443.057.638l-.057.07L6.707 6l5.147 5.146c.195.196.195.512 0 .708-.174.173-.443.192-.638.057l-.07-.057L6 6.707.854 11.854c-.196.195-.512.195-.708 0-.173-.174-.192-.443-.057-.638l.057-.07L5.293 6 .146.854C-.049.658-.049.342.146.146.32-.027.59-.046.784.09z"
                  transform="translate(-904 -224) translate(496 200) translate(400 16) translate(8 8) translate(2 2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'CloseIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
    color: VueTypes.string.def('#6783B2'),
  },
};
</script>

<style lang="scss"></style>
